import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Button, Col, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { EInput } from 'src/Components/EInput';
import { ITestContact } from '../../../../../Interfaces/TestInterface';
import DataTable from '../../../../DataTable';

interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class ContractorContacts extends React.Component {
    public props: any;
    private contacts: ITestContact[] = [];
    private dataSet: IList;

    public state = {
        contacts: this.contacts,
        dataSet: this.dataSet,
        modal: false,
        rowIndex: 0
    };

    constructor(props: any) {
        super(props);


        this.toggleModal = this.toggleModal.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleRadioSelect = this.handleRadioSelect.bind(this);
    }

    public componentDidMount() {
        this.setState({
            contacts: toJS(this.props.contractors)
        }, () => {
            this.formatDataTable();
        });
    }

    private formatDataTable() {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Name',
            'Mobile Phone',
            'Email',
            'Available',
            'On Job',
            'Email Mud Report'
        ];
        if ( this.state.contacts ) {
            this.state.contacts.map((contact: ITestContact, index: number) => {
                const newObject = [
                    {
                        content: contact.firstName + ' ' + contact.lastName
                    },
                    {
                        content: contact.phoneMobile
                    },
                    {
                        content: contact.email
                    },
                    {
                        content: contact.available
                    },
                    {
                        content: contact.onJob ? 'Yes' : 'No'
                    },
                    {
                        content: contact.emailDefaultOn ? 'Yes' : 'No'
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            dataSet: listStructure
        });
    }

    public componentWillReceiveProps(nextProps: any) {
        if ( nextProps.contractors !== this.props.contractors ) {
            this.setState({
                contacts: toJS(nextProps.contractors)
            }, () => {
                this.formatDataTable();
            });
        }
    }

    private handleEdit = (index: number) => {
        this.setState({
            rowIndex: index
        });
        this.toggleModal();
    }

    private toggleModal() {
        this.setState({
            modal: ! this.state.modal
        });
    }

    private handleInputChange(event: any) {
        const contacts = this.state.contacts;
        const row = contacts[this.state.rowIndex];
        row[event.target.name] = event.target.value;
        contacts[this.state.rowIndex] = row;
        this.setState({
            contacts
        });
    }

    private handleRadioSelect(event: any) {
        const contacts = this.state.contacts;
        const row = contacts[this.state.rowIndex];
        const onJob = event.target.value;
        row[event.target.name] = (onJob === 'true');
        row.emailDefaultOn = (onJob === 'true');
        contacts[this.state.rowIndex] = row;
        this.setState({
            contacts
        });
    }

    private handleSave() {
        this.formatDataTable();
        this.toggleModal();
        const test = toJS(this.props.test);
        test.contractorContacts = this.state.contacts;
        this.props.handleChange(test);
    }

    public render() {
        return(
            <div className="dynamic-table" style={{marginTop: '32px'}}>
                <Row className="table-header">
                    <Col lg="4">
                        <h4 className="table-h4">Contractors</h4>
                    </Col>
                </Row>
                <div className="scroll-wrapper">
                    <DataTable
                        list={this.state.dataSet}
                        onEdit={this.handleEdit}
                    />
                </div>
                { this.state.contacts.length <= this.state.rowIndex ? "" :
                <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal} backdrop="static">
                    <ModalHeader toggle={this.toggleModal}>Contractor Settings for: { this.state.contacts[this.state.rowIndex].firstName + ' ' + this.state.contacts[this.state.rowIndex].lastName }</ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Available</Label>
                                        <EInput
                                            type="select"
                                            name="available"
                                            id="available"
                                            onChange={this.handleInputChange}
                                            value={this.state.contacts[this.state.rowIndex].available}
                                        >
                                                <option disabled={true}/>
                                                <option value="Day">Day</option>
                                                <option value="Night">Night</option>
                                                <option value="Always">Always</option>
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <Label>On Job</Label><br/>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <EInput
                                                name="onJob"
                                                id="onJob"
                                                type="radio"
                                                value="true"
                                                onChange={this.handleRadioSelect}
                                                checked={this.state.contacts[this.state.rowIndex].onJob}
                                            /> Yes
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <EInput
                                                name="onJob"
                                                id="onJob"
                                                type="radio"
                                                value="false"
                                                onChange={this.handleRadioSelect}
                                                checked={!this.state.contacts[this.state.rowIndex].onJob}
                                            /> No
                                        </Label>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <Label>Email Mud Report</Label><br/>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <EInput
                                                name="emailDefaultOn"
                                                id="emailDefaultOn"
                                                type="radio"
                                                value="true"
                                                onChange={this.handleRadioSelect}
                                                checked={this.state.contacts[this.state.rowIndex].emailDefaultOn}
                                                /> Yes
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <EInput
                                                name="emailDefaultOn"
                                                id="emailDefaultOn"
                                                type="radio"
                                                value="false"
                                                onChange={this.handleRadioSelect}
                                                checked={!this.state.contacts[this.state.rowIndex].emailDefaultOn}
                                                /> No
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleModal}>Cancel</Button>
                        <Button color="primary" onClick={this.handleSave}>Save Settings</Button>
                    </ModalFooter>
                </Modal>
                }
            </div>
        );
    }

}

export default withRouter(ContractorContacts);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/WellData/ManageContacts/ContractorContactsList.tsx